// Cache transformations, but return independent trees: presentation helpers
// and transposition may mutate their own result. Bound retained source size.
const cache = new Map();
let characters = 0;
export function cachedSongContent(key, build) {
  let value = cache.get(key);
  if (value) {cache.delete(key); cache.set(key, value);}
  else {
    value = build();
    if (key.length <= 160000) {
      cache.set(key, value); characters += key.length;
      while (cache.size > 12 || characters > 160000) {
        const oldest = cache.keys().next().value;
        characters -= oldest.length; cache.delete(oldest);
      }
    }
  }
  return typeof structuredClone === 'function' ? structuredClone(value) : JSON.parse(JSON.stringify(value));
}
